import 'leaflet/dist/leaflet.css';
import './EventMapPage.css'

import { useState, useEffect } from 'react';

// import test data
// commit


import chasingTail from './chasingtail.gif';

import L from 'leaflet';
import { MapContainer, Marker, TileLayer, Popup } from 'react-leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

import orangeMarkerIcon from './marker-icon-orange.png';
import orangeMarkerIcon2x from './marker-icon-orange-2x.png';

import ExpandedEvent from '../components/ExpandedEvent';
import ListEvent from '../components/ListEvent';

import { useSearchParams } from 'react-router-dom';

// Fix Leaflet’s default icon path issue
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const defaultIcon = new L.Icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    iconAnchor: [12,41],
    iconSize: [25,41],
    popupAnchor: [0,-41],
    shadowUrl: markerShadow,
    shadowAnchor: [12,41],
    shadowSize: [41,41]
});

const orangeIcon = new L.Icon({
    iconUrl: orangeMarkerIcon,
    iconRetinaUrl: orangeMarkerIcon2x,
    iconAnchor: [19,62],
    iconSize: [38,62],
    popupAnchor: [0,-62],
    shadowUrl: markerShadow,
    shadowAnchor: [12,41],
    shadowSize: [41,41]
});

export default function EventMapPage() {

    const [data, setData] = useState(null);

    const [listShown, setListShown] = useState(false);
    
    const [searchParams, setSearchParams] = useSearchParams();
    const currentEventSearchParam = searchParams.get("event");
    const currentEvent = currentEventSearchParam == "" ? null : currentEventSearchParam;

    const handleSelectEvent = (id) => {
        setSearchParams({ event: id });
    }

    const handleBack = () => {
        setSearchParams({ });
    }

    useEffect(() => {
        fetch('https://socalfurs.com/databaseconnect.php')
            .then(res => {
                if (!res.ok) {
                    throw new Error('HTTP Error: ' + res.status);
                }
                return res.json();
            })
            .then(data => {
                setData(data);
            })
            .catch(error => {
                console.error("There was a problem with the fetch operation.", error);
            })
    }, [])

    useEffect(() => {
        if (currentEvent !== null && data !== null) {
            setListShown(true);
        }
    }, [currentEvent, data])

    
    useEffect(() => {
        const list = document.querySelector('.event-list');
        if (list) list.scrollTop = 0; // reset scroll position of the div
    }, [currentEvent]);

    return (
        
        <div className="event-map-container">
   
            {!data && (
                <div className="loader-container">
                    <div className="loader-bg">
                        <img className="loader-gif" src={chasingTail} alt="fox chasing its own tail" />
                        <span className="loader-caption">Loading...</span>
                    </div>
                </div>
            )}

            <div className={`event-map${listShown ? " darken" : ""}`}>
                <MapContainer center={[33.4270275, -117.6124179]} zoom={8} scrollWheelZoom={true} className='map-container'>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {data && data.events.map(event => {
                        if (event.lat == 0 && event.lng == 0) return null;

                        return (
                            <Marker key={event.id} position={[ event.lat, event.lng ]} icon={currentEvent == event.id ? orangeIcon : defaultIcon}>
                                <Popup>
                                    <div className="popup-content">
                                        
                                        <strong>{event.summary}</strong>
                                        <span>{event.date}</span>
                                        <button onClick={() => {
                                            setListShown(true);
                                            handleSelectEvent(event.id);
                                        }}>See More</button>
                                    </div>
                                </Popup>
                            </Marker>
                        )
                    })}
                </MapContainer>
            </div>
                    
            <div className={`list-container${listShown ? " shown" : ""}`}>
                <button className='list-showhide' onClick={() => setListShown(!listShown)}>
                    {listShown ? "Back to Map" : "See Events List"}
                </button>
                <div className="event-list">
                    {currentEvent == null && (
                        
                        <>{data && data.events.map(event => <ListEvent event={event} handleSelectEvent={handleSelectEvent} key={event.id} />)}
                        
                        </>
                    )}
                    {currentEvent != null && data  && (
                        <ExpandedEvent event={data.events.find(event => event.id == currentEvent)} handleBack={handleBack} />
                    )}
                </div>
            </div>
            {!listShown && <div className="gradient-overlay"></div>}

        </div>
    )
}
